import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import FAQs from "./pages/FAQs";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import SmoothScroll from "./components/SmoothScroll";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route
            path="/"
            element={
              <SmoothScroll>
                <Home />
              </SmoothScroll>
            }
          />
          <Route
            path="/about"
            element={
              <SmoothScroll>
                <About />
              </SmoothScroll>
            }
          />
          <Route
            path="/faqs"
            element={
              <SmoothScroll>
                <FAQs />
              </SmoothScroll>
            }
          />
          <Route
            path="/privacy"
            element={
              <SmoothScroll>
                <Privacy />
              </SmoothScroll>
            }
          />
          <Route
            path="/terms"
            element={
              <SmoothScroll>
                <Terms />
              </SmoothScroll>
            }
          />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
